import { render, staticRenderFns } from "./PhoneStepDetailVerificationCode.vue?vue&type=template&id=7cf520a9&scoped=true"
import script from "./PhoneStepDetailVerificationCode.vue?vue&type=script&lang=js"
export * from "./PhoneStepDetailVerificationCode.vue?vue&type=script&lang=js"
import style0 from "./PhoneStepDetailVerificationCode.vue?vue&type=style&index=0&id=7cf520a9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cf520a9",
  null
  
)

export default component.exports